<template>
  <section class="section">
    <div class="container">
      <!-- <LinkovaniLogotipovi /> -->
      <!-- <h1 class="title">Дневна паркинг карта</h1> -->
      <h1 class="title">Куповина паркинг карте</h1>

      <b-steps v-model="step" :has-navigation="false">
        <b-step-item label="Избор паркинг карте" icon="account-key">
          <Proizvodi />
        </b-step-item>
        <b-step-item label="Корпа" icon="account">
          <Korpa />
        </b-step-item>
        <b-step-item label="Провера" icon="account-plus">
          <Provera />
        </b-step-item>
      </b-steps>
    </div>
    <!-- <footer class="footer">
      <div class="content has-text-centered">
        <img
          src="@/assets/images/visa-mastercard-maestro-horizontal-certified.svg"
          alt="Дирекција за изградњу општине Параћин"
          class="imageCss"
        />
      </div>
    </footer> -->
    <Footer />
  </section>
</template>

<script>
import Proizvodi from '../components/Proizvodi'
import Korpa from '../components/Korpa'
import Provera from '../components/Provera'
// import LinkovaniLogotipovi from '@/components/LinkovaniLogotipovi.vue'
import Footer from '@/components/Footer.vue'

export default {
  // props: ['step'],
  components: {
    Proizvodi,
    Korpa,
    Provera,
    // LinkovaniLogotipovi,
    Footer
  },
  beforeRouteUpdate(to, from, next) {
    // console.log(to.query)
    this.step = parseInt(to.query.step)
    this.tip_karte = to.query.tip_karte
    next()
  },
  data() {
    return {
      step: parseInt(this.$route.query.step) || 0,
      tip_karte: ''
    }
  },
  computed: {}
}
</script>

<style></style>
